import PropTypes from 'prop-types';
import { useToggle } from 'usehooks-ts';
import { Stack, Typography } from '@mui/material';

import { Switch } from 'components/simple';

import { WordCloud } from './WordCloud';

export const DashboardWordCloud = ({ allDataSets = [], currentDataSet = [] }) => {
  const [isAllDataSets, toggleIsAllDataSets] = useToggle();

  return (
    <Stack spacing={3}>
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" justifyContent="space-between" spacing={2}>
        <Typography variant="h2-bold">Word Cloud</Typography>

        <Switch
          value={isAllDataSets}
          onChange={toggleIsAllDataSets}
          uncheckedLabel="Current Data Set"
          checkedLabel="All Data Sets"
        />
      </Stack>

      <WordCloud words={isAllDataSets ? allDataSets : currentDataSet} />
    </Stack>
  );
};

const wordPropTypes = {
  text: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  versions: PropTypes.arrayOf(PropTypes.string),
};

DashboardWordCloud.propTypes = {
  allDataSets: PropTypes.arrayOf(PropTypes.shape(wordPropTypes)),
  currentDataSet: PropTypes.arrayOf(PropTypes.shape(wordPropTypes)),
};
